/**
 * @file   src\components\MemberWantAd\ReportUserModal.js
 * @brief  This file is responsible for report user popup.
 * @date   June, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import { getIntroUserReportingReasons } from "../../services/commonServices";
import { reportIntroductionUser } from "../../services/introductionService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import { pageURLs } from "@/constants";

const ReportUserModal = (props) => {
  const navigate = useNavigate();
  const { IntroductionId, reportedUserId, inventoryDetails, isFromMessage } =
    props;
  const [reportReasons, setReportReasons] = useState([]);
  const [selectedReason, setSelectedReason] = useState(null);

  useEffect(() => {
    fetchReportingReasons();
  }, []);
  /**
   * To fetch rasons for reporting user
   */
  const fetchReportingReasons = async () => {
    await getIntroUserReportingReasons().then((response) => {
      if (response?.errorCode === 0) {
        setReportReasons(response?.result);
      } else {
        setReportReasons([]);
      }
    });
  };
  /**
   * To handle report user
   */
  const handleReportUser = async () => {
    const params = {
      introductionId: IntroductionId,
      reportedUserId: reportedUserId,
      reasonId: selectedReason,
    };

    await reportIntroductionUser(params)
      .then((response) => {
        props.onHide();
        if (response?.errorCode === 0) {
          toast.dismiss();
          toast.success("Report was successfully submitted");
          if (isFromMessage) {
            props.onHide();
          } else {
            navigate(pageURLs.allIntroductions);
          }
        } else {
          toast.dismiss();
          toast.error(response?.message);
        }
      })
      .catch((err) => {
        toast.dismiss();
        toast.error(err);
      });
  };

  const handleCancel = () => {
    setSelectedReason(null);
    props.onHide();
  };

  return (
    <Modal
      show
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-settings modal-payment cancel-plan"
    >
      <Modal.Body className="pt-32 pb-32">
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={props.onHide}
        ></button>
        <h3 className="text-start">Report user</h3>
        <p className="desc">
          Your report is always anonymous. Once the report is made we'll
          investigate the situation and determine what to do next.
        </p>
        <p className="note">Reason for reporting:</p>
        <div className="modal-controls-wrap">
          {reportReasons.length > 0 &&
            reportReasons.map((reason) => {
              return (
                <label className="radio-wrap mb-3">
                  <input
                    type="radio"
                    name="radio-ad-option"
                    onChange={() => {
                      setSelectedReason(reason?.ReasonId);
                    }}
                    checked={reason?.ReasonId === selectedReason}
                  />
                  <span>{reason?.Reason_Text}</span>
                </label>
              );
            })}
        </div>

        <div className="modal-btn-wrap">
          <Button className="btn btn-tertiary me-2" onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            variant="primary"
            disabled={selectedReason == null}
            onClick={() => handleReportUser()}
          >
            Report user
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default ReportUserModal;
